import { PAGINATION_ALL_ITEMS_SIZE } from '../constants/pagination'
import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function getRequestChecklists(requestId, params) {
  return getApi({
    endpoint: `api/request/${requestId}/widget_checklist/`,
    params,
  })
}

export function getChecklistItems(checklistId, params) {
  return getApi({
    endpoint: 'api/checkitem/',
    params: {
      checklist: checklistId,
      page_size: PAGINATION_ALL_ITEMS_SIZE,
      ...params,
    },
  })
}

export function getChecklistTemplates(params) {
  return getApi({ endpoint: 'api/checklist-tiny/', params })
}

export function createChecklist(data) {
  return postApi({ data, endpoint: 'api/checklist/' })
}

export function deleteChecklist(id) {
  return deleteApi({ endpoint: `api/checklist/${id}/` })
}

export function createChecklistItem(data) {
  return postApi({ data, endpoint: 'api/checkitem/' })
}

export function updateChecklistItem(id, data) {
  return patchApi({ data, endpoint: `api/checkitem/${id}/` })
}

export function deleteChecklistItem(id) {
  return deleteApi({ endpoint: `api/checkitem/${id}/` })
}
